import React, { ComponentType } from "react";
import { useFlag } from "@unleash/proxy-client-react";

import { UNLEASH_GUEST_CHECKOUT } from "../../../helpers/constants";

// Supply the hook value to the existing class component.
const withGuestCheckoutFlag = <P extends object>(
  Component: ComponentType<P & { isGuestCheckoutEnabled: boolean }>
) => {
  const WithGuestCheckoutFlag = (props: P) => {
    const isGuestCheckoutEnabled = useFlag(UNLEASH_GUEST_CHECKOUT);
    return <Component {...props} isGuestCheckoutEnabled={isGuestCheckoutEnabled} />;
  };

  return WithGuestCheckoutFlag;
};

export default withGuestCheckoutFlag;
